// GENERATED — DO NOT HAND-EDIT.
//
// Source of truth: specs/tier-05-experience/widget-installation.entity-hint.yaml
// Generator: tools/v2-gen/v2gen.py
// Regenerate via: make v2-generate-screens
//
// Hand-edits to non-override-block content WILL be lost on next
// regeneration. See specs/_product/dashboard-v2-page-generator.md §5
// for override blocks (imports / helpers / header-actions).

import type { ListPageConfig } from "../../components/composition/ListPage";
import { widgetInstallationsApi } from "../../api/widget-installations";
import type { WidgetInstallation } from "../../api/types";
// override-block:imports BEGIN
// CHG-2463 / ITER-905205 — Widget Studio S4. widget_instance_id renders as a
// link to the owning instance detail; `link` is not a built-in DataTable cell
// type so the generator emits a custom column bound to a render helper here.
import { createElement } from "react";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
// override-block:imports END

// override-block:helpers BEGIN
function widgetInstanceIdColumn(row: WidgetInstallation): ReactNode {
  const id = row.widget_instance_id;
  if (!id) {
    return createElement("span", { style: { color: "var(--color-text-subtle)" } }, "—");
  }
  return createElement(
    Link,
    {
      to: `/channels/widgets/${id}`,
      style: { color: "var(--color-link)", fontFamily: "var(--font-mono, monospace)", fontSize: 12 },
      onClick: (e: { stopPropagation: () => void }) => e.stopPropagation(),
    },
    `${id.slice(0, 8)}…`,
  );
}
// override-block:helpers END

export const widgetInstallationListConfig: ListPageConfig<WidgetInstallation> = {
  title: "Installations",
  subtitle: "Observed embed locations of your widgets, by domain and page.",
  queryKey: ["widget-installations", "list"] as const,
  queryFn: ({ page, pageSize, sortField, sortDirection, search, filters }) =>
    widgetInstallationsApi.listWidgetInstallations({ page, pageSize, sortField, sortDirection, search, filters }),
  defaultSort: { field: "last_seen_at", direction: "desc" },
  pageSize: 50,
  rowHref: "/channels/widgets/installations/{id}",
  search: { enabled: true, placeholder: "Search installations by domain…" },
  emptyState: {
    title: "No installations observed yet",
    subtitle: "Installations appear here once a widget renders on one of your pages.",
  },
  headerActions: [
    // override-block:header-actions BEGIN
    // override-block:header-actions END
  ],
  filters: [
    { field: "widget_instance_id", label: "Widget", type: "entity-search", targetEntity: "widget-instance" },
  ],
  filterChips: [
    { id: "status-active", label: "Active", field: "status", value: "active", group: "status" },
    { id: "status-observed", label: "Observed", field: "status", value: "observed", group: "status" },
    { id: "status-stale", label: "Stale", field: "status", value: "stale", group: "status" },
    { id: "status-removed", label: "Removed", field: "status", value: "removed", group: "status" },
    { id: "status-blocked", label: "Blocked", field: "status", value: "blocked", group: "status" },
    { id: "status-error", label: "Error", field: "status", value: "error", group: "status" },
  ],
  columns: [
    { field: "domain", label: "Domain", type: "text", sortable: true },
    { field: "widget_instance_id", label: "Widget", type: "custom", render: widgetInstanceIdColumn },
    { field: "status", label: "Status", type: "lifecycle-badge" },
    { field: "url_pattern", label: "URL pattern", type: "text" },
    { field: "last_seen_at", label: "Last seen", type: "datetime", sortable: true },
    { field: "render_count", label: "Renders", type: "number", sortable: true },
  ],
};
